import { normalizeUserRoles } from './maintenance-mode';

export interface IUserWithRole {
  role?: string | string[] | null;
}

export function userHasRole(user: IUserWithRole | null | undefined, role: string): boolean {
  return normalizeUserRoles(user?.role).includes(role);
}

export function userHasAdminRole(user: IUserWithRole | null | undefined): boolean {
  return userHasRole(user, 'admin');
}

/**
 * The cross-tenant platform administrator role. Compared without case, as the
 * Hub API does.
 */
export function userHasDomainAdminRole(user: IUserWithRole | null | undefined): boolean {
  return normalizeUserRoles(user?.role).some((role) => typeof role === 'string' && role.toLowerCase() === 'domainadmin');
}

/**
 * The stored `system` user is a placeholder for automated changes. Only a
 * platform administrator sees it, read-only.
 */
export function isSystemAccount(user: { key?: unknown } | null | undefined): boolean {
  return typeof user?.key === 'string' && user.key.toLowerCase() === 'system';
}

/**
 * The Hub API answers 403 with this key when someone tries to change the
 * default admin account, its own preferences included. The account's key is
 * configurable, so callers react to this key, not to a user name.
 */
export const ADMIN_ACCOUNT_PROTECTED_KEY = 'admin_account_protected';

/** The Hub API answers 403 with this key when someone deletes a protected account. */
export const USER_CAN_NOT_BE_DELETED_KEY = 'user_can_not_be_deleted';

export function isAdminRoute(path: string): boolean {
  return path === '/admin' || path.startsWith('/admin/');
}
